<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import authservice from "./auth/authService.js"
export default {
  name: "app",
  created: function () {
    authservice.authLogin().then(res => {
      this.$router.replace("/File")
    })
  }
}

</script>

<style>
#id {
  height: 100%;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// App.vue?1b1cf3e8